module.exports = __webpack_public_path__ + "30653924d279b57af8012a1bb3ce1ac1.svg";